import { useRouter } from 'next/router'
import { setToken } from '@/utils/checkLogin'
import useStorage from '@/utils/useStorage'
import _ from 'lodash'

// 登陆后处理缓存
export default function useAfterLogin({
  rememberPassword,
  noRedirect = false
}: {
  rememberPassword?: boolean
  noRedirect?: boolean
}) {
  const [loginParams, setLoginParams, removeLoginParams] = useStorage('loginParams')
  const { query } = useRouter()

  function afterLoginSuccess(params?: Record<string, any>, data?: Record<string, any>) {
    // 记住密码
    if (rememberPassword) {
      setLoginParams(JSON.stringify(params))
    } else {
      removeLoginParams()
    }
    // 记录登录状态
    if (data?.data?.access_token) {
      setToken(data?.data?.access_token)
    }

    if (noRedirect) {
      window.location.reload()
    } else {
      window.location.href = '/board'
    }
  }

  function afterPhoneLoginSuccess(params?: Record<string, any>, data?: Record<string, any>) {
    // 记住密码
    if (rememberPassword) {
      setLoginParams(JSON.stringify(params))
    } else {
      removeLoginParams()
    }
    // 记录登录状态
    if (data?.data?.access_token) {
      setToken(data?.data?.access_token)
    }

    if (noRedirect) {
      window.location.reload()
    } else {
      window.location.href = '/board'
    }
  }

  return { loginParams, afterLoginSuccess, afterPhoneLoginSuccess }
}
